import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { userService } from '@/services/database';
import type { FinancialValueDisplayPreference } from '@/types/financialValueDisplay';

export const ACCOUNT_FINANCIAL_VALUE_PREFERENCES_QUERY_KEY = ['userPreferences', 'account'] as const;

export const useAccountFinancialValueDisplayPreference = () => {
    const query = useQuery({
        queryKey: ACCOUNT_FINANCIAL_VALUE_PREFERENCES_QUERY_KEY,
        queryFn: () => userService.getPreferences('account'),
    });

    return {
        ...query,
        preference: query.data?.preferences?.financialValues?.display as
            FinancialValueDisplayPreference | null | undefined,
    };
};

export const useUpdateAccountFinancialValueDisplayPreference = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (display: FinancialValueDisplayPreference | null) =>
            userService.updatePreferences({ financialValues: { display } }, 'account'),
        onSuccess: (data) => {
            queryClient.setQueryData(ACCOUNT_FINANCIAL_VALUE_PREFERENCES_QUERY_KEY, data);
        },
    });
};
